import React from 'react';
import { Facebook, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1D1534] text-white py-8 mt-50px">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center sm:text-left">
          <img src="/images/footerFisiko.svg" alt="Fisiko" className="text-5xl
           whitespace-nowrap text-white max-md:text-4xl " />
          <p className="text-sm">Address, State, Country, Pin</p>
          </div>
          
          <div className="text-center sm:text-left">
            <h3 className="font-bold mb-4 underline">FEATURES</h3>
            <ul className="space-y-2 text-sm">
              <li>Sports Profile</li>
              <li>Set Matches</li>
              <li>Track Games</li>
              <li>Social Media</li>
            </ul>
          </div>
          
          <div className="text-center sm:text-left">
            <h3 className="font-bold mb-4 underline">FOLLOW US ON</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center justify-center sm:justify-start">
                <Facebook size={16} className="mr-2" /> facebook
              </li>
              <li className="flex items-center justify-center sm:justify-start">
                <Instagram size={16} className="mr-2" /> instagram
              </li>
              <li className="flex items-center justify-center sm:justify-start">
                <Youtube size={16} className="mr-2" /> youtube
              </li>
            </ul>
          </div>
          
          <div className="text-center sm:text-left">
            <h3 className="font-bold mb-4 underline">COMPANY</h3>
            <ul className="space-y-2 text-sm">
              <li>Privacy Policy</li>
              <li>Terms and Conditions</li>
              <li>About Us</li>
              <a href='/login'><li><span className="text-orange-500">Login / Sign Up</span></li></a>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 text-xs text-center">
          © 2024 Fisiko. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;